import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { ProyectoResponse } from "../../../shared/response/proyectos/ProyectoResponse";
import { ProyectoPayload } from "../../../shared/services/api/payload/proyectos/ProyectoPayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { dateToMs, grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { ProyectoService, toProyectoResponse } from "./ProyectoService";

/** Alta y edición de proyectos; el resultado reemplaza la fila del listado. */
export class ProyectoSaveService extends ServiceSaveBase<ProyectoResponse, ProyectoPayload> {
  protected readonly cache = ProyectoService.instance;

  /**
   * gRPC-Web (`GuardarProyecto`): el alta congela el snapshot activo (error si no hay ninguno) y las tasas de
   * la cosecha vigente. Sin núcleo, el alta hereda el del último proyecto del cliente.
   */
  protected async sendSave(p: ProyectoPayload): Promise<ProyectoResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).guardarProyecto({
      id: p.id ?? undefined,
      nombre: p.nombre,
      clienteId: p.clienteId,
      cultivoId: p.cultivoId,
      tecnicoId: p.tecnicoId,
      ha: p.ha,
      fincaId: p.fincaId ?? undefined,
      variedad: p.variedad ?? undefined,
      municipio: p.municipio ?? undefined,
      fechaInicio: dateToMs(p.fechaInicio),
      nota: p.nota ?? undefined,
      macroProyectoId: p.macroProyectoId ?? undefined,
      nucleoId: p.nucleoId ?? undefined,
      duracionMeses: p.duracionMeses ?? undefined,
      entidadFinancieraReferencia: p.entidadFinancieraReferencia ?? undefined,
      limiteFinancieroReferencial: p.limiteFinancieroReferencial !== null ? BigInt(Math.round(p.limiteFinancieroReferencial)) : undefined,
    }));
    return toProyectoResponse(r);
  }
}
